import { createSlice } from '@reduxjs/toolkit';

const singleRecurring = createSlice({
  name: 'singleRecurring',
  initialState: {
    date: null,
    isEditingRecurring: false,
    isLoading: false,
    recurring: [],
    slotsToDelete: [],
  },
  reducers: {
    setRecurring(state, { payload }) {
      const { recurring, date } = payload;
      return {
        date,
        isLoading: false,
        recurring,
        slotsToDelete: [],
      };
    },
    addPlaceholder(state) {
      state.recurring = [
        ...state.recurring,
        {
          eventDate: '',
          start: '',
          end: '',
          uuid: crypto.randomUUID(),
          isPlaceholder: true,
        },
      ];
    },
    editPlaceholder(state, { payload }) {
      const { uuid, start, end, eventDate } = payload;

      const updatedAvailability = state.recurring.map((slot) => {
        if (slot.uuid === uuid) {
          return {
            ...slot,
            eventDate,
            start: `${eventDate}T${start}`,
            end: `${eventDate}T${end}`,
          };
        }
        return slot;
      });

      state.recurring = updatedAvailability;
    },

    removeRange(state, { payload }) {
      const { uuid, isPlaceholder } = payload;

      const rangeToDelete = state.recurring
        .map((range) => {
          if (range.uuid === uuid) {
            return {
              ...range,
              isPlaceholder: true,
            };
          }
          return null;
        })
        .filter(Boolean);

      if (!isPlaceholder) {
        // If it's a real slot we'll delete it later
        state.slotsToDelete = [...state.slotsToDelete, rangeToDelete[0]];
      }
      state.recurring = state.recurring.filter((range) => range.uuid !== uuid);
    },
  },
});

const { actions, reducer } = singleRecurring;

export const { setRecurring, addPlaceholder, editPlaceholder, removeRange } =
  actions;

export default reducer;
